"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AppSettings_1 = tslib_1.__importDefault(require("../../apiServices/auth/AppSettings"));
var AbilityService_1 = require("../../apiServices/auth/AbilityService");
var SceFeatures = /** @class */ (function () {
    function SceFeatures() {
    }
    SceFeatures.prototype.getTitleLabel = function () {
        AppSettings_1.default.verifyUrlInitializationState();
        switch (AppSettings_1.default.productVariantName) {
            case 'AM': return "Stream Calculation Engine";
            case 'SCE': return "Compute Model Engineering";
            default: return '';
        }
    };
    SceFeatures.prototype.isConditionSupported = function () {
        AppSettings_1.default.verifyUrlInitializationState();
        if (AppSettings_1.default.productVariantName == "AM")
            return true;
        else
            return false;
    };
    SceFeatures.prototype.getTypeLabel = function () {
        AppSettings_1.default.verifyUrlInitializationState();
        switch (AppSettings_1.default.productVariantName) {
            case 'AM': return "Asset Model Type";
            case 'SCE': return "Compute Model Type";
            default: return '';
        }
    };
    SceFeatures.prototype.isDeveloper = function () {
        if (AbilityService_1.AbilityService.userRoles.includes("SoftwareDeveloper") || AbilityService_1.AbilityService.userRoles.includes("LibraryDeveloper")) {
            return true;
        }
        return false;
    };
    return SceFeatures;
}());
exports.SceFeatures = SceFeatures;
//# sourceMappingURL=SceFeatures.js.map